import { minutesToTime, timeToMinutes } from "./agenda-time";

/** Coluna "Sem sala" da agenda por sala. */
export const SEM_SALA = "-";

/** ID estável de um slot: "YYYY-MM-DD|HH:MM", mais "|<sala>" na agenda por sala. */
export function buildSlotId(date: Date, time: string, sala?: string): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}|${time}${sala ? `|${sala}` : ""}`;
}

/** Parse de um slot id. Retorna null se inválido. `salaId` só vem na agenda por sala (null = sem sala). */
export function parseSlotId(id: string): { date: Date; time: string; salaId?: string | null } | null {
  const [dateStr, time, sala] = id.split("|");
  if (!dateStr || !time) return null;
  const [y, m, d] = dateStr.split("-").map(Number);
  if (!y || !m || !d) return null;
  return { date: new Date(y, m - 1, d), time, ...(sala ? { salaId: sala === SEM_SALA ? null : sala } : {}) };
}

/** Dado um startTime e duração, calcula o endTime (clampado ao endHour). */
export function computeEndTime(
  startTime: string,
  durationMinutes: number,
  endHour: string,
): string {
  const end = Math.min(
    timeToMinutes(startTime) + durationMinutes,
    timeToMinutes(endHour),
  );
  return minutesToTime(end);
}

/** Calcula a duração em minutos entre startTime e endTime ("HH:MM"). */
export function appointmentDuration(startTime: string, endTime: string): number {
  return timeToMinutes(endTime) - timeToMinutes(startTime);
}

type ConflictAppt = {
  id: string;
  startTime: string;
  endTime: string;
  status?: string | null;
};

/**
 * Checa se um range proposto conflita com algum appointment existente na lista.
 * Ignora o proprio appointment (ignoreId) e consultas canceladas/faltas.
 */
export function hasRangeConflict(
  appointments: ConflictAppt[],
  start: string,
  end: string,
  ignoreId?: string,
): boolean {
  const startMin = timeToMinutes(start);
  const endMin = timeToMinutes(end);
  if (startMin >= endMin) return false;
  for (const a of appointments) {
    if (ignoreId && a.id === ignoreId) continue;
    if (a.status === "CANCELLED" || a.status === "NO_SHOW") continue;
    const aStart = timeToMinutes(a.startTime);
    const aEnd = timeToMinutes(a.endTime);
    if (aStart < endMin && aEnd > startMin) return true;
  }
  return false;
}
